import React from 'react';
import { Button } from '@/components/ui/button';
import { Trophy, ClipboardList, ArrowLeft, History } from 'lucide-react';

interface TournamentHeaderProps {
  title: string;
  language: string;
  showBack?: boolean;
  onBack?: () => void;
  showLeaderboard: boolean;
  onToggleLeaderboard: () => void;
  onHistory?: () => void;
}

export const TournamentHeader: React.FC<TournamentHeaderProps> = ({
  title,
  language,
  showBack = false,
  onBack,
  showLeaderboard,
  onToggleLeaderboard,
  onHistory,
}) => {
  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
      <div className="flex items-center gap-2">
        {showBack && (
          <Button
            variant="outline"
            size="sm"
            onClick={onBack}
            className="text-xs sm:text-sm"
          >
            <ArrowLeft className="h-3 w-3 sm:h-4 sm:w-4" />
            <span className="hidden sm:inline ml-1">
              {language === 'no' ? 'Tilbake' : 'Back'}
            </span>
          </Button>
        )}
        <h2 className="font-bold text-lg sm:text-xl flex items-center gap-2">
          <Trophy className="text-primary flex-shrink-0" />
          <span className="truncate">{title}</span>
        </h2>
      </div>
      <div className="flex gap-2 flex-shrink-0">
        <Button
          variant="outline"
          size="sm"
          onClick={onToggleLeaderboard}
          className="text-xs sm:text-sm min-w-0"
        >
          <ClipboardList className="mr-1 sm:mr-2 h-3 w-3 sm:h-4 sm:w-4 flex-shrink-0" />
          <span className="whitespace-nowrap">
            {showLeaderboard 
              ? (language === 'no' ? 'Skjul resultater' : 'Hide results')
              : (language === 'no' ? 'Vis resultater' : 'Show results')}
          </span>
        </Button>
        {onHistory && (
          <Button
            variant="outline"
            size="sm"
            onClick={onHistory}
            className="text-xs sm:text-sm min-w-0"
          >
            <History className="mr-1 sm:mr-2 h-3 w-3 sm:h-4 sm:w-4 flex-shrink-0" />
            <span className="whitespace-nowrap">History</span>
          </Button>
        )}
      </div>
    </div>
  );
};

